export const UI_LABELS = Object.freeze({
  ORDER_ID: "Order Id",
  APPLICATION_NO: "Application No",
  BILLING_NAME: "Billing Name",
  BILLING_PHONE_NUMBER: "Billing Phone Number",
  TOTAL_ORDER_AMOUNT: "Total Order Amount",
  PENDING_AMOUNT: "Pending Amount",
  ORDER_PUNCH_DATE: "Order Punch Date",
});
